import { useEffect, useState } from "react";
import { base44 } from "@/api/base44Client";
import ListingCard from "./ListingCard";

export default function NewListingsSection({ hideLocation }) {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const all = await base44.entities.Listing.list("-dateLaunched", 10);
        if (!active) return;
        const featured = all.filter(l => l.featured);
        const result = (featured.length >= 2 ? featured : all).slice(0, 2);
        setListings(result);
      } catch (e) {
        /* entity may be empty */
      }
      if (active) setLoading(false);
    })();
    return () => { active = false; };
  }, []);

  return (
    <section style={{ backgroundColor: "#112215", paddingTop: "clamp(60px, 7vw, 96px)", paddingBottom: "clamp(60px, 7vw, 96px)", paddingLeft: "clamp(20px, 5vw, 80px)", paddingRight: "clamp(20px, 5vw, 80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }} className="new-listings-grid">
          <div>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#CCF5AC", marginBottom: 14, marginTop: 0 }}>New listings</p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 46px)", letterSpacing: "-0.02em", lineHeight: 1.12, color: "#F4F1E7", marginTop: 0, marginBottom: 20 }}>Fresh stays,<br />recently launched.</h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 16, color: "rgba(244,241,231,0.82)", lineHeight: 1.7, marginTop: 0, marginBottom: 0 }}>
              Browse our newest short-lets live across the UK. Every property is professionally managed, photographed and set up to perform from day one.
            </p>
          </div>
          <div>
            {loading ? (
              <div className="new-listings-cards" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {[0, 1].map(i => <div key={i} style={{ background: "rgba(255,255,255,0.08)", borderRadius: 16, aspectRatio: "3 / 4" }} />)}
              </div>
            ) : listings.length === 0 ? (
              <p style={{ color: "rgba(244,241,231,0.5)", fontFamily: "'DM Sans', sans-serif", fontSize: 14 }}>No listings yet.</p>
            ) : (
              <div className="new-listings-cards" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {listings.map(l => <ListingCard key={l.id} listing={l} hideLocation={hideLocation} />)}
              </div>
            )}
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .new-listings-grid { grid-template-columns: 1fr !important; gap: 36px !important; }
          .new-listings-cards { grid-template-columns: 1fr !important; }
        }
        .listing-card:hover { box-shadow: 0 12px 32px rgba(0,0,0,0.1); transform: translateY(-2px); }
        .listing-card:hover .listing-nav { opacity: 1 !important; }
      `}</style>
    </section>
  );
}